import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import StatisticalDivisionService from "@services/StatisticalDivisionService";

const ShowStatisticalDivision = ({ statisticalDivision }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [statisticalDivisionData, setStatisticalDivisionData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      StatisticalDivisionService.find(statisticalDivision.id).then(
        (response) => {
          setStatisticalDivisionData(response.data.data);
        }
      );
  }, [statisticalDivision.id, showModal]);

  return (
    <PermissionHandler permission={"view_statistical_divisions"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={statisticalDivisionData.name} />
          <RowDetails
            label={t("nameEng")}
            value={statisticalDivisionData.name_eng}
          />
          <RowDetails
            label={t("description")}
            value={statisticalDivisionData.description}
          />
          <RowDetails
            label={t("subAreaName")}
            value={statisticalDivisionData?.sub_area?.name}
          />
          <RowDetails
            label={t("subAreaNameEng")}
            value={statisticalDivisionData?.sub_area?.name_eng}
          />
          <RowDetails
            label={t("subAreaDescription")}
            value={statisticalDivisionData?.sub_area?.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowStatisticalDivision;
